import { Component } from 'react';

import Box from '@mui/material/Box';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';
import { flowRight as compose } from 'lodash';

import AxlButton from 'AxlMUIComponent/AxlButton';
import AxlInput from 'AxlMUIComponent/AxlInput';
import styles from './styles';

class ShipmentPickupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  save = (e) => {
    const { shipmentStore, shipment, pickup, closeForm } = this.props;
    shipmentStore.updateShipmentPickup(
      shipment,
      pickup,
      () => {
        closeForm();
      },
      (error) => {
        this.setState({ error: error.message });
      },
    );
  };

  render() {
    const { shipmentStore } = this.props;
    const { shipmentPickupForm, updatingShipmentPickup } = shipmentStore;
    return (
      <div style={styles.Container}>
        <Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1, ...styles.GroupPanel }}>
              <div style={styles.GroupField}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <div style={styles.GroupField}>
                      <div style={styles.GroupTitle}>{`Address Line 1`}</div>
                      <div style={styles.Field}>
                        <AxlInput
                          value={shipmentPickupForm.getField('address.street', '')}
                          onChange={shipmentPickupForm.handlerInput}
                          placeholder={`Address Line 1`}
                          name={`address.street`}
                          type={`text`}
                          fluid
                        />
                      </div>
                      <div style={styles.GroupTitle}>{`Address Line 2`}</div>
                      <div style={styles.Field}>
                        <AxlInput
                          value={shipmentPickupForm.getField('address.street2', '')}
                          onChange={shipmentPickupForm.handlerInput}
                          placeholder={`Address Line 2`}
                          name={`address.street2`}
                          type={`text`}
                          fluid
                        />
                      </div>
                      <Box sx={{ display: 'flex' }}>
                        <Box sx={{ flex: 1 }}>
                          <div style={styles.GroupTitle}>{`City`}</div>
                          <div style={styles.Field}>
                            <AxlInput
                              value={shipmentPickupForm.getField('address.city', '')}
                              onChange={shipmentPickupForm.handlerInput}
                              placeholder={`City`}
                              name={`address.city`}
                              type={`text`}
                              fluid
                            />
                          </div>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <div style={styles.GroupTitle}>{`State`}</div>
                          <div style={styles.Field}>
                            <AxlInput
                              value={shipmentPickupForm.getField('address.state', '')}
                              onChange={shipmentPickupForm.handlerInput}
                              placeholder={`State`}
                              name={`address.state`}
                              type={`text`}
                              fluid
                            />
                          </div>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <div style={styles.GroupTitle}>{`Zipcode`}</div>
                          <div style={styles.Field}>
                            <AxlInput
                              value={shipmentPickupForm.getField('address.zipcode', '')}
                              onChange={shipmentPickupForm.handlerInput}
                              placeholder={`Zipcode`}
                              name={`address.zipcode`}
                              type={`text`}
                              fluid
                            />
                          </div>
                        </Box>
                      </Box>
                      {/*<div style={styles.GroupTitle}>{`Remark`}</div>*/}
                      {/*<div style={styles.Field}><AxlInput value={pickupStopForm.getField('remark', '')} onChange={pickupStopForm.handlerInput} placeholder={`Remark`} name={`remark`} type={`text`} fluid /></div>*/}
                      {/*<div style={styles.GroupTitle}>{`Actual Departure`}</div>*/}
                      <div style={styles.GroupTitle}>{`Pickup Notes`}</div>
                      <div style={styles.Field}>
                        <AxlInput
                          value={shipmentPickupForm.getField('note', '')}
                          onChange={shipmentPickupForm.handlerInput}
                          placeholder={`Pickup Notes`}
                          name={`note`}
                          type={`text`}
                          fluid
                        />
                      </div>
                    </div>
                  </Box>
                </Box>
              </div>
            </Box>
          </Box>
          {this.state.error && (
            <ul style={styles.listError}>
              <li style={styles.errorText}>{this.state.error}</li>
            </ul>
          )}
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <div style={{ ...styles.Field, ...styles.FieldButton }}>
                  <AxlButton compact bg={`gray`} onClick={this.props.closeForm} style={styles.buttonControl}>{`Cancel`}</AxlButton>
                </div>
                <div style={{ ...styles.Field, ...styles.FieldButton }}>
                  <AxlButton
                    loading={updatingShipmentPickup}
                    compact
                    bg={`pink`}
                    onClick={this.save}
                    style={styles.buttonControl}
                  >{`Save`}</AxlButton>
                </div>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
    );
  }
}
export default compose(withRouter, inject('store'), observer)(ShipmentPickupForm);
